
export default {
  // apiPath: 'https://citadel-devops-api-production.herokuapp.com/api/v1',
  apiPath: 'https://devops.citadel-services.com/api/v1',
};
